import { CKBox, CKButton, CKLayoutGridAuto } from 'clearkit';
import { useState } from 'react';

import AuthLayout, { AuthLayoutHeader } from '~/components/layouts/AuthLayout';

import TextFieldWithValidations from '../shared/TextFieldWithValidations';
import useCreateProfileAndSignIn from './useCreateProfileAndSignIn';

type CreateProfileValidationErrors = {
  first_name?: string[];
  last_name?: string[];
};

export default function CreateHubspotProfile() {
  const [firstName, setUserFirstName] = useState('');
  const [lastName, setUserLastName] = useState('');
  const [validationErrors, setValidationErrors] = useState<
    CreateProfileValidationErrors
  >({});

  const { isLoading, mutateAsync } = useCreateProfileAndSignIn();

  async function createAccount() {
    const { isSuccess, error } = await mutateAsync({
      firstName,
      lastName,
    });

    if (isSuccess) {
      setValidationErrors({});
      window.location.href = '/';
      return;
    }

    if (error.action === 'unauthorized') {
      window.location.href = `/auth/login?error=${error.type}`;
      return;
    }

    if (error.error?.type === 'validation') {
      setValidationErrors(error.error.errors);
    }
  }

  return (
    <AuthLayout>
      <AuthLayoutHeader
        className="sm:w-80"
        description="Provide your details below and we will sign you into your account."
        header={
          <div className="w-full font-semibold text-center">
            Create your Clearbit profile
          </div>
        }
      />
      <CKBox className="w-full p-5 sm:w-[440px]">
        <div className="flex flex-col gap-6">
          <CKLayoutGridAuto gap="1.5rem">
            <TextFieldWithValidations
              name="first_name"
              onChange={setUserFirstName}
              placeholder="First name"
              validationErrors={validationErrors}
              value={firstName}
            />
            <TextFieldWithValidations
              name="last_name"
              onChange={setUserLastName}
              placeholder="Last name"
              validationErrors={validationErrors}
              value={lastName}
            />
          </CKLayoutGridAuto>
          <div>
            <CKButton
              isLoading={isLoading}
              onClick={createAccount}
              variant="bold"
              variantColor="blue"
            >
              Create profile
            </CKButton>
          </div>
        </div>
      </CKBox>
    </AuthLayout>
  );
}
